import * as React from "react";
import type { SVGProps } from "react";

interface VideoReviewSuccessProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const VideoReviewSuccess = ({ cancelled = false, ...props }: VideoReviewSuccessProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.25 2.25)">
        <circle
          cx={7.5}
          cy={7.5}
          r={8.57}
          fill="#60B100"
          stroke="#FFF"
          strokeWidth={2.15}
        />
        <circle cx={7.5} cy={7.5} r={8.15} stroke="#000" strokeWidth={1.3} />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          fillRule="evenodd"
          stroke="#000"
          strokeWidth={1.25}
          d="m12.32 5.62.98.4a1.06 1.06 0 0 1 .44 1.5l-3.98 5.77c-.24.35-.63.55-1.04.58-.4.03-.82-.1-1.11-.41l-2.7-2.78a1.06 1.06 0 0 1 .05-1.53l.48-.39a1.06 1.06 0 0 1 1.43.1l1.56 1.6 3.02-4.38c.2-.3.53-.46.87-.46Z"
        />
        <path
          stroke="#FFF"
          strokeWidth={0.25}
          d="m11.86 6.37 1.23.1a.56.56 0 0 1 .22.78L9.35 13a.88.88 0 0 1-.66.37.91.91 0 0 1-.73-.26l-2.69-2.78a.56.56 0 0 1 .02-.8l.46-.37a.56.56 0 0 1 .76.05l1.99 2.04z"
        />
      </g>
      <g transform="translate(9 16.25)">
        <rect
          width={14.75}
          height={7.75}
          x={-0.88}
          y={-0.88}
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={1.75}
          rx={0.35}
        />
        <rect width={14} height={7} x={-0.5} y={-0.5} stroke="#000" rx={0.35} />
      </g>
      <path
        fill="#000"
        fillRule="nonzero"
        d="M11.75 21.57a.6.6 0 0 1-.32-.1.5.5 0 0 1-.2-.27l-1.24-3.74c-.05-.16-.05-.28 0-.37.06-.08.17-.13.35-.13.23 0 .38.12.46.36l.95 3.08.95-3.08c.08-.24.23-.36.48-.36.14 0 .25.05.3.14.07.09.07.2.02.36l-1.23 3.74a.5.5 0 0 1-.2.27c-.1.06-.21.1-.32.1m1.97-.02c-.13 0-.23-.05-.28-.13s-.05-.2 0-.34l1.34-3.8c.08-.2.22-.32.44-.32h.06c.21 0 .36.11.43.32l1.34 3.8c.05.14.05.26 0 .34s-.14.13-.28.13h-.13c-.22 0-.36-.12-.43-.34l-.18-.57h-1.59l-.18.57c-.07.22-.21.34-.43.34zm.98-1.7h1.07l-.53-1.66zm3.38 1.7c-.26 0-.4-.15-.4-.44V17.4c0-.3.14-.44.4-.44h1.6c.27 0 .5.05.7.13.2.1.36.23.47.43.1.2.16.46.16.8 0 .4-.08.71-.25.92-.17.2-.4.34-.69.4l.64 1.4c.07.14.09.27.04.36q-.06.15-.27.15h-.12q-.345 0-.48-.33l-.63-1.55h-.77v1.44c0 .3-.13.44-.4.44m.4-2.67h1.09c.18 0 .33-.04.43-.13.11-.09.16-.23.16-.44 0-.2-.05-.34-.16-.43a.67.67 0 0 0-.43-.13h-1.09z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default VideoReviewSuccess;
